module.exports = __webpack_public_path__ + "img/journal.c8abd9ee.jpeg";